<template>
    <div id="redirectDiv">
    </div>
</template>

<script>
export default {
  name: 'Redirect',
  components: {
  },
  beforeCreate () {
    document.title = this.$route.params.testdata+' - Labotist'
  },
  data () {
    return {
        currentLocation : {}
    }
  },
  mounted () { 
  },
  created () {
      this.geolocation()
  },
  methods: {
    geolocation: function () {
      var options = {
        maximumAge:60000, 
        timeout:5000, 
        enableHighAccuracy:true
      }
      navigator.geolocation.getCurrentPosition(function (position) {
        console.log('im tracking you!')
        this.currentLocation = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        }
        this.changeCityUsingLocation()
        return false
      }.bind(this), function (error) {
        if (error.code === error.PERMISSION_DENIED) {
          console.log('you denied me :-(')
          setTimeout(function(){
              this.$router.push({ path: '/labs/chennai/' + this.$route.params.testdata })
          }.bind(this), 500)
        }
      }.bind(this)),
      options
    },
    changeCityUsingLocation: function () {
      var data = {
        coordinates : this.currentLocation
      }
      Promise.resolve(this.$POST('patient/getCityUsingLocation', data)).then(function (res) {
        if (res.response_code === 0) {
            if(res.response.cityName) {
              let laburl = '/labs/'+res.response.cityName+'/' + this.$route.params.testdata;
              if (res.response.locationName) {
                laburl = laburl + '/' + res.response.locationName
              }
              this.$router.push({ path: laburl })
            } else {
              this.$router.push({ path: '/labs/chennai/' + this.$route.params.testdata })
            }
        } else {
          this.$router.push({ path: '/labs/chennai/' + this.$route.params.testdata })
        }
      }.bind(this)).catch(function (err) {
        console.error(err)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/web/Public/LabRedirect.vue